import { Component, input } from '@angular/core';
import { Size } from '../common/types';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'lepi-spinner',
  imports: [Icon],
  template: `
    <section class="flex items-center justify-center w-full h-full">
      <lepi-icon
        [size]="size()"
        class="spinner-icon animate-spin text-primary"
        name="mdi:loading" />
    </section>
  `,
  styleUrl: './spinner.component.css',
})
export class Spinner {
  size = input<Size>('md'); // 기본 크기는 'md'로 설정
}
